import { m8API } from 'services/production/m8';
import { SendAuthEmailService } from 'types/services';

export const sendAuthEmail: SendAuthEmailService = async (params) => {
  const { emailAddress } = params;

  await m8API.auth.sendAuthorisationCodeOnEmail({ email: emailAddress });
};
